module.exports = __webpack_public_path__ + "img/list31.cd634b63.jpeg";